module.exports = __webpack_public_path__ + "img/police_officer_recruitment.f1f9ca4c.jpg";